import React, {useState} from 'react';

import {useStateValue} from "./state";

const Lookup = () => {

    const [{operation}, dispatch] = useStateValue();
    const [{metadata}, ] = useStateValue();

    const t = metadata.Table;
    let target;

    if(operation.index) {
        const inx = t.GlobalSecondaryIndexes.filter(item => item.IndexName === operation.index);
        target = inx[0];

    } else {
        target = t;
    }

    const AttributeDefinitions = t.AttributeDefinitions;

    const pkName = (target ? target.KeySchema[0].AttributeName : null);
    const skName = (target && target.KeySchema.length > 1 ? target.KeySchema[1].AttributeName : null);


    const pkType = AttributeDefinitions.filter((item) => {
        return (item.AttributeName === pkName);
    })[0].AttributeType;

    const skType = !skName ? null : AttributeDefinitions.filter((item) => {
        return (item.AttributeName === skName);
    })[0].AttributeType;

    const pkTypeFull = pkType === 'S' ? 'string' : (pkType === 'N' ? 'number' : 'binary') ;
    const skTypeFull = skType === 'S' ? 'string' : (skType === 'N' ? 'number' : 'binary') ;

    // const pk = operation.pk;
    //
    // const sk = operation.sk;

    const [pk, setPk] = useState(operation.pk);
    const [sk, setSk] = useState(operation.sk);

    const handleSubmit = (event) => {
        event.preventDefault();

        let op;
        let typedPk;
        let typedSk;


        if(pkType === 'N') {
            typedPk = parseInt(pk);
        } else {
            typedPk = pk;
        }
        if(skType === 'N') {
            typedSk = parseInt(sk);
        } else {
            typedSk = sk;
        }

        if(skName && !sk ) {
            // we have a composite key with null SK, therefore a query
            op = {action:'query',target:operation.target, index:operation.index, pk:typedPk, sk: null };

        } else {

            if(operation.index) { // GSI does not support GET or even unique PK-SK items
                op = {action:'query',target:operation.target, index:operation.index, pk:typedPk, sk: typedSk ? typedSk : null };

            } else {
                op = {action:'get',target:operation.target, index:operation.index, pk:typedPk, sk: typedSk ? typedSk : null };
            }

        }

        dispatch({"type":"setOperation", "operation": op});

    };
    const clearSkForQuery = (event) => {
        setSk('');
    }

    return (
        <form onSubmit={handleSubmit}>
            <table className="metadataSummary">
                <tbody>

                <tr >
                    {/*<td className='summaryLabel'>Operation</td>*/}
                    {/*<td className='summaryData'>{operation.action}</td>*/}

                    <td className='summaryLabel'>Partition (hash) Key:</td>

                    <td className='partitionKey'>
                        {pkName} ({pkTypeFull})</td>

                    <td className='summaryLabel'>

                        <input type="text" name="pk"
                               className='inputBoxPk'
                               defaultValue={operation.pk}
                               onChange={e => setPk(e.target.value)}/>
                    </td>

                    <td className='summaryData'>

                        <input type="submit" value={skName ? 'QUERY' : 'GET'} className="lookupButton" onClick={clearSkForQuery}/>

                    </td>
                </tr>

                <tr >

                    {skName ? (<td className='summaryLabel'>Sort (range) Key:</td>) : (<td> </td>)}
                    {skName ? (<td className='sortKey'>{skName} ({skTypeFull})</td>) : (<td> </td>)}

                    {skName ? (<td className='summaryLabel'>

                                    <input type="text" name="sk"
                                           className='inputBoxSk'
                                           defaultValue={operation.sk}
                                           onChange={e => setSk(e.target.value)}/>

                    </td>) : (<td> </td>)}
                    {skName ? (<td className='summaryData'>

                                <input type="submit" value={operation.index ? "QUERY" : "GET"} className="lookupButton"/>

                               </td>) : (<td> </td>)}

                </tr>
                </tbody>
            </table>
        </form>
    );


};

export default Lookup;

